import http from 'conversations-http/clients/http';
export const fetchPreviousMessageHistoryHtml = ({
  threadIds
}) => http.get(`conversations-email/v1/app-messages/thread/${threadIds && threadIds.first() // we only show one thread history at a time
}/chat-history-html`);